import {tanyapendeta} from "./main_04_B.js";
import React from 'react'; 
import ReactDOM from 'react-dom/client';
import CreateReactClass from "create-react-class";
var p;

export function f_comment_box(id){

var container = "p_"+id;
p = document.getElementById(container).innerHTML;
console.log(p);
 var comment_box = CreateReactClass({
  displayName: "comments",

  _shoots: function _shoots(){
    

    document.getElementById("black_container").style.display = "none";
   document.getElementById("app").style.display = "block";

  },

  
  getInitialState: function getInitialState() {
    return {
      comments: []
    
    };
  },

  _eachComment: function _eachComment(text, i) {
    return React.createElement(
      Comment,
      { key: i, index: i, removeComment: this._deleteComment },
      text
    );
  },

  _addComment: function _addComment(text) {

var g = document.getElementById("textarea").value;
if (g.trim() !== "") {


tanyapendeta(p,document.getElementById("textarea").value,document.getElementById("contact").value)
//k_redering_in(document.getElementById("textarea").value);
//here
document.getElementById("black_container").style.display = "none";
document.getElementById("app").style.display = "block";
  }

  },

_lightup: function _lightup(){

  document.getElementById("textarea").addEventListener("input",   
function hideOnEmpty() {
    var text = this.value;
    if (text !== ''){
          document.getElementById("inebox01-c-textarea").style.backgroundColor = "orange"; 
    }
    else{
          document.getElementById("inebox01-c-textarea").style.backgroundColor = "rgba(0,0,0,0.5)"; 
    }
});

}
,
  _handleKeyPress: function _handleKeyPress(e) {
    if (e.key === "Enter") {
      this._addComment(this.refs.newText.value);
      this.refs.newText.value = "";
      e.preventDefault();
    }
  },

  render: function render() {
    return React.createElement(
      "div",
    {className: "inebox01_B_Element" ,id:"inebox01"},
      React.createElement(
        "div",
          {className: "inebox01-a" },
          React.createElement(
            "span",
              {},
              "Tanya Kami"        
            ),
          React.createElement (
            "div",
            {className: "exit", id:"exit",onClick : this._shoots },
            React.createElement(
              "i",
              {className: "fa fa-times"}
              )
            )
        ),
      React.createElement(
        "div",
          {className: "inebox01-b_B_Element" },
          React.createElement(
            "div",
            null,
            React.createElement(
              input_box,null
              )
            ),
          React.createElement(
            "textarea",
               {placeholder: "Apa Soalan yang anda fikirkan...?", id:"textarea", ref: "newText", onClick: this._lightup }
            //  "span",
             //  {className: "inner_add_area", placeholder: "Write a comment..." },
              // "apa Soalan yang menyinggung, anda?"
        )
        ),React.createElement(
  "div",
  {className: "B_container"},
  React.createElement(Message, null),
  React.createElement(Creator, null)
),
      React.createElement(
        "div",
          {className: "inebox01-c" , onClick : this._addComment, id:"inebox01-c"},
          React.createElement(
            "div",
              {id:"inebox01-c-textarea"},
            "Tanya"
            )
        )
    );
  }
  });

 return comment_box;
}


var input_box = CreateReactClass({
  displayName: "Creator",

  getDefaultProps: function getDefaultProps() {
    return {
      name: "anonymous"
    };
  },

  render: function render() {
    return React.createElement(
        "div",
        { className: "input_B_Element" },
        React.createElement("img", null),
        React.createElement("textarea", {id:"contact", ref: "newText", onKeyPress: this._handleKeyPress, placeholder: "FB, IG or Whtsp..."})
      )    
  }
});




export var Creator = CreateReactClass({
  displayName: "Creator",

  getDefaultProps: function getDefaultProps() {
    return {
      name: "anonymous"
    };
  },

  render: function render() {
    return React.createElement(
      "div",
      { className: "creator_B_Element" },
      React.createElement(
        "div",
        {className:"Creator_container_B_Element"},
        React.createElement("div",null,
        React.createElement(
          "p",
          null,
          this.props.name,
        ),
             React.createElement("p",null,"30")
        )
      )
      ,React.createElement("img", null),
      );
  }
});


export var Message = CreateReactClass({
  displayName: "Message",

  render: function render() {
    return React.createElement(
      "div",
      { className: "message_con"},
      React.createElement(
      "p",
      { className: "message_con_p" },
      p
    ),
       React.createElement(
      "div",
      { className: "message_con_B" }
    )
      );
  }
});

var Post = React.createElement(
  "div",
  null,
  React.createElement(Creator, null),
  React.createElement(Message, null)
);
